import SignupPaymentActionType from '../../common/SignupPaymentActionType';

const initialState = {
  plan: {},
  contract: '',
  promotionCode: null,
  validatedPromoCode: false,
  formValues: {
    firstName: '',
    lastName: '',
    email: '',
    contactNumber: '',
    password: '',
    confirmPassword: '',
    connectionDate: '',
    currentBroadbandProvider: 0,
    landline: '',
    existingLandlineProvider: 0,
    modemDelivery: '',
    modemName: '',
    modemCompany: '',
    modemAddress: '',
    modemSuburb: '',
    modemCity: '',
    modemPostcode: '',
    receiveUpdates: false,
    acceptTerms: false
  },
  clickDetails: {
    clickStatus: true,
    clickTokenId: '',
    clickTransactionId: '',
    clickSessionId: '',
  },
  clickErrorStatus: {
    error: false,
    errorMessage: ''
  }
};

const PaymentReducer = (state = initialState, action) => {
  switch (action.type) {
    case SignupPaymentActionType.STORE_PAYMENT_DETAILS: {
      return Object.assign({}, state, { formValues: action.formValues });
    }
    case SignupPaymentActionType.RESET_ALL: {
      return initialState;
    }
    case SignupPaymentActionType.VALIDATE_PROMO_CODE: {
      return Object.assign({}, state, {
        promotionCode: action.promotionCode,
        validatedPromoCode: action.validatedPromoCode
      });
    }
    case SignupPaymentActionType.CLICK_GATEWAY_DETAILS: {
      return Object.assign({}, state, {
        clickDetails: action.clickDetails
      });
    }

    case SignupPaymentActionType.CLICK_ERROR_MESSAGE_UPDATE: {
      return Object.assign({}, state, {
        clickErrorStatus: action.clickErrorStatus
      });
    }
    default:
      return state;
  }
};

export const PaymentSelector = {
  getGivenName: state => state.payment.formValues.firstName,
  getSurname: state => state.payment.formValues.lastName,
  getEmail: state => state.payment.formValues.email,
  getContactNumber: state => state.payment.formValues.contactNumber,
  getConnectionDate: state => state.payment.formValues.connectionDate,
  getPreferredDate: state => state.payment.formValues.preferredDate,
  getModemDelivery: state => state.payment.formValues.modemDelivery,
  getModemName: state => state.payment.formValues.modemName,
  getModemCompany: state => state.payment.formValues.modemCompany,
  getModemAddress: state => state.payment.formValues.modemAddress,
  getModemSuburb: state => state.payment.formValues.modemSuburb,
  getModemCity: state => state.payment.formValues.modemCity,
  getModemPostcode: state => state.payment.formValues.modemPostcode,
  getModemDeliveryInstructions: state => state.payment.formValues.modemDeliveryInstructions,
  getClickDetails: state => state.payment.clickDetails,
  getClickErrorStatus: state => state.payment.clickErrorStatus
};

export default PaymentReducer;



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/PaymentReducer.js
 **/